import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const StyledDiv = styled.div`
    border-top: 1px solid ${COLOR_VALUES.Gray_6};
    padding-top: 16px;
`;
